export const HOLD_EXPIRATION_DEFAULT = 365;
